export const fetcher = async (url: string, options?: object) => {
  const currentURL = window.location.href;
  if (currentURL.includes('localhost')) {
    const defaultOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    const response = await fetch('http://localhost:8080/' + url, options || defaultOptions);
    const data = await response.json();
    return data;
  }
  else {
    const defaultOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }

    const response = await fetch(url, options || defaultOptions);
    const data = await response.json();
    return data;
  }

};
